import { isModalFormActive } from "@/features/post/components/forms/postFormLifecycle";
import { ThreadCreateForm } from "@/features/thread/components/forms/ThreadCreateForm";
import { PersistentModal } from "@/shared/ui/overlay";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const ThreadCreateModal: React.FunctionComponent<Props> = ({
  isOpen,
  onClose,
}: Props) => {
  return (
    <PersistentModal
      isOpen={isOpen}
      onClose={onClose}
      title="新規スレッド"
      position="bottom"
    >
      <section className="p-4" aria-label="新規スレッドフォーム">
        <ThreadCreateForm
          active={isModalFormActive(isOpen)}
          onSuccess={onClose}
        />
      </section>
    </PersistentModal>
  );
};
